/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Breadcrumbs } from '@coursera/cds-core';

import type { Domain } from 'bundles/browse-common/types/domain';

import _t from 'i18n!nls/browse-common';

type Props = {
  domain: Domain;
};

const BrowseBreadcrumbsComponent = (props: Props) => {
  const { domain } = props;

  const urlRoot = '/browse';

  return (
    <Breadcrumbs variant="link">
      <Breadcrumbs.Item href={urlRoot}>{_t('Explore categories')}</Breadcrumbs.Item>
      <Breadcrumbs.Item href={`${urlRoot}/${domain.slug}`}>{domain.name}</Breadcrumbs.Item>
    </Breadcrumbs>
  );
};

export default BrowseBreadcrumbsComponent;
